import React, { memo } from "react";
import { Position } from "@xyflow/react";
import { DistributionNodeData } from "../flow-utils";
import CircleHandle from "../../handles/circle";
import { TbCircleLetterJ } from "react-icons/tb";
import TooltipHorizon from "widgets/controls/tooltip";

const CONNECTION_POINT_SIZE = 40;

const DistributionNode = (props: { data: DistributionNodeData }) => {
  const { data } = props;
  const size = data.width ?? CONNECTION_POINT_SIZE;

  const node = (
    <div
      className="border-stone-400 flex items-center justify-center rounded-full border-2 bg-white shadow-md"
      style={{ width: size, height: size }}
      key={data.id}
    >
      <TbCircleLetterJ className="text-3xl text-blue-500" />
      {/* Target handle - flow in */}
      <CircleHandle
        type="target"
        position={data.targetPosition ?? Position.Left}
        width={data.width}
        height={data.height}
      />
      {/* Source handle - flow out */}
      <CircleHandle
        type="source"
        position={data.sourcePosition ?? Position.Right}
        width={data.width}
        height={data.height}
      />
    </div>
  );

  return data.name ? (
    <TooltipHorizon
      trigger={node}
      content={<span>{data.name}</span>}
      placement="top"
      extra=""
    />
  ) : (
    node
  );
};

export default memo(DistributionNode);
